import { get } from 'svelte/store';
import { accessToken } from '../stores/cachedStores';

const apiBasePath = document.currentScript.getAttribute('apiPath');
const w3 = new Web3(Web3.givenProvider);
let accounts;

async function handleResponse(response)
{
    if (response.status >= 200 && response.status <= 299) {
        const jsonResponse = await response.json();
        if (jsonResponse.payload)
            return jsonResponse.payload;
        else
            return jsonResponse;
    } else {
        const jsonResponse = await response.json();
        throw {status: response.status, statusText: response.statusText, errorMessage: jsonResponse.error};
    }
}

export async function connectMetaMask()
{
    if (typeof window.ethereum !== 'undefined')
    {
        ethereum.request({ method: 'eth_requestAccounts' });
        console.log('MetaMask is installed!');
        accounts = await w3.eth.getAccounts();
        console.log('Accounts: ' + JSON.stringify(accounts));
        
        const response = await fetch(apiBasePath + '/auth/eth/' + accounts[0] + '/challenge', {
            method: 'POST',
            headers: {'Content-Type': 'application/json' },
            body: JSON.stringify({web_provider: "Metamask"})
        });

        let jsonResponse = await handleResponse(response);
        
        return {accounts: accounts, challenge: jsonResponse.challenge};
    }
    else
        throw {status: 500, statusText: "Error", errorMessage: "MetaMask not installed"};
}

export async function loginMetaMask(challenge)
{
    accounts = await w3.eth.getAccounts();
    console.log('Accounts: ' + JSON.stringify(accounts));

    const signature = await w3.eth.personal.sign(challenge, accounts[0], (e, r) => console.log(e, r));

    await new Promise(r => setTimeout(r, 500)); //wait a bit, for some stupid reason

    const response = await fetch(apiBasePath + '/auth/eth/' + accounts[0] + '/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        body: JSON.stringify({signature: signature, web_provider: "Metamask"})
    })
    
    return handleResponse(response);
}

export async function getUserData(userId)
{
    const response = await fetch(apiBasePath + '/api/users/' + userId, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + get(accessToken) }
    })
    
    return handleResponse(response);
}

export async function getUserFriends(userId)
{
    const response = await fetch(apiBasePath + '/api/users/' + userId + "/friends/all", {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + get(accessToken) }
    })
    
    return handleResponse(response);
}

/*export async function unfriendUser(userId, friendId)
{
    const response = await fetch(apiBasePath + '/api/users/' + userId + "/friends", {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + get(accessToken) },
        body: JSON.stringify([friendId])
    })
    
    return handleResponse(response);
}*/

export async function reportUser(userId, category, subcat, message)
{
    const response = await fetch(apiBasePath + "/api/report", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + get(accessToken) },
        body: JSON.stringify({uid: userId, category: category, subcat: subcat, desc: message})
    })
    
    return handleResponse(response);
}

export async function updateUserName(userId, userName)
{
    const formData = new FormData();
    formData.append("name", userName);

    const response = await fetch(apiBasePath + '/api/users/' + userId, {
        method: 'PATCH',
        headers: { 'Authorization': 'Bearer ' + get(accessToken) },
        body: formData
    });
    
    return handleResponse(response);
}

export async function addBalance(userId, balance)
{
    const formData = new FormData();
    formData.append("balance", balance);

    const response = await fetch(apiBasePath + '/api/sfs/users/' + userId, {
        method: 'PATCH',
        headers: { 'Authorization': 'Bearer ' + get(accessToken) },
        body: formData
    });
    
    return handleResponse(response);
}

export async function getCasinos()
{
    const response = await fetch(apiBasePath + '/api/casinos', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + get(accessToken) }
    })
    
    return handleResponse(response);
}

export async function getTables(casinoId)
{
    const response = await fetch(apiBasePath + '/api/poker_tables/by_casino/' + casinoId, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + get(accessToken) }
    })
    
    return handleResponse(response);
}